import { render } from "./EditProductPriceTemplateModal.vue?vue&type=template&id=1981c390"
import script from "./EditProductPriceTemplateModal.vue?vue&type=script&lang=js"
export * from "./EditProductPriceTemplateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__